<p class="su-body">
  @for (segment of segments(); track $index) {
    @if (segment.kind === 'text') {
      <span>{{ segment.text }}</span>
    } @else if (canOpen(segment.page)) {
      <a class="su-page-link" [routerLink]="segment.page.route">
        <cm-ui-chip size="sm" icon="arrow_outward" [label]="segment.page.label | translate" />
      </a>
    } @else {
      <span class="su-page-name">{{ segment.page.label | translate }}</span>
    }
  }
</p>
